import {
  Box,
  Button,
  Checkbox,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Radio,
  RadioGroup,
  Spacer,
  Spinner,
  Switch,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { DisciplineSelector } from "../Signup/DisciplineSelector";
import { OfiDateTimeRangePicker } from "../../Helpers/Time";
import { FieldValidator } from "./createEventModal";
import { ArrowUpDownIcon } from "lucide-react";
import { useAwaitResponse } from "../../../Api/HttpRequestHelpers";
import { Discipline_GET } from "../../../Api/dto/Discipline_GET";
import { Competition_GET } from "../../../Api/dto/Competition_GET";
import {
  PaymentMethod,
  PaymentMethodE,
} from "../../../Api/dto/Competition_POST_PUT";
import {
  Discipline_POST_PUT,
  Gender,
  ResultType,
} from "../../../Api/dto/Discipline_POST_PUT";
import {
  CompetitionClient,
  DisciplineClient,
} from "../../../Api/client/CompetitionClient";
import { DiscountDto_PUT } from "../../../Api/dto/DiscountDtos";
import { DiscountsEditView } from "./DiscountsEditView";
import { StartnumberSequencesDto } from "../../../Api/dto/StartnumberSequence_GET_PUT";
import { config } from "process";
import { AdminClient } from "../../../Api/client/AdminClient";
import { toast } from "react-toastify";

//import DatePicker from "react-date-picker";

const NOT_VALID_TEMP_ID = -1;
const NOT_VALID_POSITION = -1;
const DEFAULT_NEW_DISCIPLINE: Discipline_GET = {
  name: "",
  description: "",
  signupCostInSek: 0,
  minAge: null,
  maxAge: null,
  groupSize: null,
  signupOpenTime: null,
  signupClosedTime: null,
  id: NOT_VALID_TEMP_ID,
  displayOrder: NOT_VALID_POSITION,
  deleted: false,
  startNumberSequences: [],
  genderRequirements: [],
  distanceInMeters: 0,
  resultType: ResultType.INDIVIDUAL,
};
type ExtendedPaymentMethodType = PaymentMethod & { selected: boolean };

const GENDER_MAN = "man";
const GENDER_WOMAN = "woman";
const GENDER_ASK = "ask";
const GENDER_IRRELEVANT = "irrelevant";

const gendersToString = (genders: Array<Gender>) => {
  return genders.length === 0
    ? GENDER_IRRELEVANT
    : genders.length === 2
    ? GENDER_ASK
    : genders[0] === Gender.MAN
    ? GENDER_MAN
    : genders[0] === Gender.WOMAN
    ? GENDER_WOMAN
    : GENDER_IRRELEVANT;
};

const stringToGenders = (genders: string) => {
  return genders === GENDER_MAN
    ? [Gender.MAN]
    : genders === GENDER_WOMAN
    ? [Gender.WOMAN]
    : genders === GENDER_ASK
    ? [Gender.MAN, Gender.WOMAN]
    : genders === GENDER_IRRELEVANT
    ? []
    : [];
};

const resultTypeToString = (resultType: ResultType) => {
  return resultType === ResultType.GROUP ? "GROUP" : "INDIVIDUAL";
};

const stringToResultType = (resultType: string) => {
  return resultType === "GROUP" ? ResultType.GROUP : ResultType.INDIVIDUAL;
};

export function SetupSignupModal(props: {
  competition: Competition_GET;
  onClose: () => void;
}) {
  const [disciplines, isLoadingDisciplines, setDisciplines] = useAwaitResponse(
    [] as Array<Discipline_GET>,
    () =>
      DisciplineClient.admin.getAllDisciplines(
        props.competition.id,
        props.competition.tag || ""
      ),
    (response) => response
  );

  const [swishAuto, setSwishAuto] = useState<
    ExtendedPaymentMethodType | undefined
  >();
  const [swishMan, setSwishMan] = useState<
    ExtendedPaymentMethodType | undefined
  >();
  const [directMan, setDirectMan] = useState<
    ExtendedPaymentMethodType | undefined
  >();
  const [invoiceMan, setInvoiceMan] = useState<
    ExtendedPaymentMethodType | undefined
  >();

  const [isValueFromProps, setIsValueFromProps] = useState(false);

  useEffect(() => {
    console.log("Props payment method changed and are read again");
    props.competition.paymentMethods.forEach((pm) => {
      if (pm.paymentMethod === PaymentMethodE.SWISH_AUTO) {
        setSwishAuto({ ...pm, selected: true });
      }
      if (pm.paymentMethod === PaymentMethodE.INVOICE_MAN) {
        setInvoiceMan({ ...pm, selected: true });
      }
      //if (pm.paymentMethod === PaymentMethodE.SWISH_MAN) {
      //setSwishMan({...pm, selected: true});
      //}
      //if (pm.paymentMethod === PaymentMethodE.DIRECT_MAN) {
      //setDirectMan({...pm, selected: true});
      //}
    });
    setIsValueFromProps(true);
  }, [props.competition.paymentMethods]);

  const [selectedDisciplines, setSelectedDisciplines] = useState<
    Discipline_GET[]
  >([]);

  const [discountUpdates, setDiscountUpdates] = useState<DiscountDto_PUT[]>([]);

  const [startnumberSequences, setStartnumberSequences] = useState<
    Array<StartnumberSequencesDto>
  >([]);

  return (
    <Modal
      closeOnOverlayClick={false}
      scrollBehavior={"inside"}
      isOpen={true}
      size={"full"}
      onClose={() => {
        props.onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent
        background={"white"}
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <ModalHeader>Skapa event</ModalHeader>
        <ModalCloseButton />
        <ModalBody scrollBehavior={"auto"} margin={"20px"}>
          <Tabs>
            <TabList>
              <Tab>Startgrupper</Tab>
              <Tab>Betalning</Tab>
              <Tab>Rabatter</Tab>
              <Tab>Startnummer</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <div style={{ marginBottom: "60px" }}>
                  <Spinner hidden={!isLoadingDisciplines} />
                  <VStack align="left" hidden={isLoadingDisciplines}>
                    <Heading
                      size={"md"}
                      marginTop={"20px"}
                      marginBottom={"0px"}
                    >
                      Skapa/ändra startgrupper
                    </Heading>

                    <InputStartGroup
                      startTime={
                        new Date(
                          props.competition.startTime || new Date().getTime()
                        )
                      }
                      onSubmit={(discipline: Discipline_GET) => {
                        if (discipline.id === NOT_VALID_TEMP_ID) {
                          discipline.id = getNextTempId(disciplines);
                        }
                        if (discipline.displayOrder === NOT_VALID_POSITION) {
                          discipline.displayOrder =
                            getNextPosition(disciplines);
                        }
                        setSelectedDisciplines([]);
                        setDisciplines((old) => {
                          return [
                            ...old.filter((d) => d.id !== discipline.id),
                            discipline,
                          ];
                        });
                      }}
                      onToggleDelete={(discipline: Discipline_GET) => {
                        if (
                          discipline.deleted ||
                          window.confirm(
                            "Är du säker på att du vill ta bort startgruppen?"
                          )
                        ) {
                          setSelectedDisciplines([]);
                          if (discipline.id <= NOT_VALID_TEMP_ID) {
                            setDisciplines((old) =>
                              old.filter((d) => d.id !== discipline.id)
                            );
                          } else {
                            setDisciplines((old) => {
                              return [
                                ...old.filter((d) => d.id !== discipline.id),
                                { ...discipline, deleted: !discipline.deleted },
                              ];
                            });
                          }
                        }
                      }}
                      onMoveUp={() => {
                        /*
                        setDisciplines((old) => {
                          const [above, selected, below] = findNeighbours(
                            old,
                            selectedDisciplines[0]
                          );
                          if (above !== undefined && selected !== undefined) {
                            const selectedPosition = selected.displayOrder;
                            const abovePosition = above.displayOrder;
                            return [
                              ...old.filter((d) => {
                                return (
                                  d.id !== above.id && d.id !== selected.id
                                );
                              }),
                              { ...above, displayOrder: selectedPosition },
                              {
                                ...selected,
                                displayOrder: abovePosition,
                              },
                            ];
                          }
                          return old;
                        });
                        */
                      }}
                      onMoveDown={() => {
                        /*
                        setDisciplines((old) => {
                          const [above, selected, below] = findNeighbours(
                            old,
                            selectedDisciplines[0]
                          );
                          if (below !== undefined && selected !== undefined) {
                            const selectedPosition = selected.displayOrder;
                            const belowPosition = below.displayOrder;
                            return [
                              ...old.filter((d) => {
                                return (
                                  d.id !== below.id && d.id !== selected.id
                                );
                              }),
                              { ...below, displayOrder: selectedPosition },
                              {
                                ...selected,
                                displayOrder: belowPosition,
                              },
                            ];
                          }
                          return old;
                        });
                      }*/
                      }}
                      onSwitchSelectedDisciplines={() => {
                        const position0 = selectedDisciplines[0].displayOrder;
                        const id0 = selectedDisciplines[0].id;
                        const position1 = selectedDisciplines[1].displayOrder;
                        const id1 = selectedDisciplines[1].id;

                        setDisciplines((old) => {
                          //selectedDisciplines[0].displayOrder =
                          //selectedDisciplines[1].displayOrder;
                          //selectedDisciplines[1].displayOrder = position0;
                          const first = old.find((d) => d.id === id0);
                          const second = old.find((d) => d.id === id1);
                          if (first !== undefined && second !== undefined) {
                            return [
                              ...old.filter(
                                (d) =>
                                  d.id !== selectedDisciplines[0].id &&
                                  d.id !== selectedDisciplines[1].id
                              ),
                              { ...first, displayOrder: position1 },
                              { ...second, displayOrder: position0 },
                            ];
                          }
                          return old;
                        });
                        setSelectedDisciplines([]);
                      }}
                      selectedDisciplines={selectedDisciplines}
                    />

                    <DisciplineSelector
                      disciplines={disciplines}
                      eventStart={
                        new Date(props.competition.startTime ?? Date.now())
                      }
                      selectLimit={2}
                      onSelect={(selections: Discipline_GET[]) => {
                        setSelectedDisciplines(selections);
                      }}
                      initialSelections={selectedDisciplines}
                      showDeleted
                    />
                  </VStack>
                </div>
              </TabPanel>
              <TabPanel>
                <Heading size={"sm"} marginTop={"20px"} marginBottom={"0px"}>
                  Välj betalningsform(er)
                </Heading>
                <PaymentOption
                  name={"Swish (automatisk)"}
                  description="Swish betalning där anmälan först accepteras när betalningen blivit genomförd (automatisk verifiering)."
                  value={swishAuto}
                  allowSettingRequireManualVerify={false}
                  onChange={(
                    selected: boolean,
                    fee: number,
                    requireManualVerification: boolean
                  ) => {
                    setSwishAuto({
                      paymentMethod: PaymentMethodE.SWISH_AUTO,
                      feeInSek: fee,
                      selected: selected,
                      requireManualVerify: requireManualVerification,
                    });
                    setIsValueFromProps(false);
                    console.log("payment update");
                  }}
                />
                {/**
                <PaymentOption
                  name={"Swish (manuell)"}
                  description="Swish betalning där betalnings verifiering görs manuellt. Det går att välja om anmälan accepteras direkt, eller om den accepterats först när betalningen har verifierats manuellt. Användaren behöver verifiera sin email address."
                  value={swishMan}
                  allowSettingRequireManualVerify={true}
                  onChange={(
                    selected: boolean,
                    fee: number,
                    requireManualVerification: boolean,
                  ) => {
                    setSwishMan(
                      {
                        paymentMethod: PaymentMethodE.SWISH_MAN,
                        feeInSek: fee,
                        selected: selected,
                        requireManualVerify: requireManualVerification,
                      });
                      setIsValueFromProps(false);
                      console.log("payment update");
                  }}
                />
                <PaymentOption
                  name={"Bankgiro"}
                  description="Bankgiro betalning där betalnings verifiering görs manuellt. Det går att välja om anmälan accepteras direkt, eller om den accepterats först när betalningen har verifierats manuellt. Användaren behöver verifiera sin email address."
                  value={directMan}
                  allowSettingRequireManualVerify={true}
                  onChange={(
                    selected: boolean,
                    fee: number,
                    requireManualVerification: boolean,
                  ) => {
                    setDirectMan(
                      {
                        paymentMethod: PaymentMethodE.DIRECT_MAN,
                        feeInSek: fee,
                        selected: selected,
                        requireManualVerify: requireManualVerification,
                      });
                      setIsValueFromProps(false);
                      console.log("payment update");
                  }}
                />
                 */}
                <PaymentOption
                  name={"Faktura"}
                  description="Faktura betalning där fakturering och betalningsverifiering görs manuellt. Bekräftelsemail och tillägg i startlistan sker direkt. Användaren behöver verifiera sin email address."
                  value={invoiceMan}
                  allowSettingRequireManualVerify={false}
                  onChange={(
                    selected: boolean,
                    fee: number,
                    requireManualVerification: boolean
                  ) => {
                    setInvoiceMan({
                      paymentMethod: PaymentMethodE.INVOICE_MAN,
                      feeInSek: fee,
                      selected: selected,
                      requireManualVerify: requireManualVerification,
                    });
                    setIsValueFromProps(false);
                    console.log("payment update");
                  }}
                />
              </TabPanel>
              <TabPanel>
                <Heading size={"sm"} marginTop={"20px"} marginBottom={"0px"}>
                  Hantera rabatter
                </Heading>
                <DiscountsEditView
                  competitionId={props.competition.id}
                  disciplines={disciplines}
                  discountUpdates={discountUpdates}
                  setDiscountUpdates={setDiscountUpdates}
                />
              </TabPanel>
              <TabPanel>
                <Heading size={"sm"} marginTop={"20px"} marginBottom={"0px"}>
                  Hantera startnummer serier
                </Heading>
                <StartnumberSeriesEditView
                  competitionId={props.competition.id}
                  competitionTag={props.competition.tag}
                  onUpdate={(a: Array<StartnumberSequencesDto>) => {
                    setStartnumberSequences(a);
                  }}
                />
                <Tooltip
                  label={
                    "Tilldela alla löpare som saknar nummerlappar en nummerlapp enlight serierna ovan. Görs normalt endast just efter att startnummer sekvenserna är satta."
                  }
                >
                  <Button
                    margin="50px"
                    padding={"20px"}
                    colorScheme="yellow"
                    onClick={() => {
                      CompetitionClient.admin
                        .putStartnumberAssignment(props.competition.id)
                        .then(() => {
                          toast.success(
                            "Tilldelningen av startnummer är slutförd"
                          );
                        })
                        .catch(() => {
                          toast.error(
                            "Tilldelningen av startnummer misslyckades"
                          );
                        });
                    }}
                  >
                    Tilldela startnummer
                  </Button>
                </Tooltip>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
        <ModalFooter borderRadius={"0px"} background={"blue.100"}>
          <HStack>
            <Button
              onClick={() => {
                saveDisciplines(props.competition.id, disciplines);
                if (!isValueFromProps) {
                  console.log("Set updates", swishAuto, invoiceMan);
                  savePaymentMethods(
                    props.competition,
                    [swishAuto, swishMan, directMan, invoiceMan]
                      .filter((p) => p != undefined && p.selected)
                      .map((p) => {
                        const tmp = { ...p } as any;
                        delete tmp["selected"];
                        return tmp as PaymentMethod;
                      })
                  );
                }
                if (startnumberSequences.length > 0) {
                  DisciplineClient.admin.putStartnumbers(
                    props.competition.tag ?? "NO_COMPETITION_TAG",
                    startnumberSequences
                  );
                }
                discountUpdates.forEach((d) => {
                  CompetitionClient.admin.putDiscount(props.competition.id, d);
                });
                props.onClose();
              }}
            >
              {" "}
              Spara{" "}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

function InputStartGroup(props: {
  startTime: Date;
  onSubmit: (discipline: Discipline_GET) => void;
  onToggleDelete: (discipline: Discipline_GET) => void;
  onSwitchSelectedDisciplines: () => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  selectedDisciplines: Discipline_GET[];
}) {
  const [discipline, setDiscipline] = useState<Discipline_GET>(
    props.selectedDisciplines.length === 1
      ? props.selectedDisciplines[0]
      : { ...DEFAULT_NEW_DISCIPLINE }
  );

  const [genders, setGenders] = useState<string>(
    gendersToString(discipline.genderRequirements)
  );

  useEffect(() => {
    setDiscipline(
      props.selectedDisciplines.length === 1
        ? props.selectedDisciplines[0]
        : { ...DEFAULT_NEW_DISCIPLINE }
    );
    if (props.selectedDisciplines.length === 1) {
      setGenders(
        gendersToString(props.selectedDisciplines[0].genderRequirements)
      );
    }
  }, [props.selectedDisciplines]);

  useEffect(() => {
    const v = stringToGenders(genders);
    setDiscipline((d) => ({ ...d, genderRequirements: v }));
  }, [genders]);

  return (
    <Box
      borderRadius={"20px"}
      background={
        props.selectedDisciplines.length > 0 ? "yellow.300" : "blue.50"
      }
      padding={"20px"}
      width={"fit-content"}
      transition="all 0.3s"
    >
      <HStack marginLeft={"10px"}>
        <Text>Startgrupp:</Text>
        <Input
          margin={"10px"}
          width="3xs"
          textColor={"black"}
          placeholder="Grupp (Ex. P15)"
          isDisabled={props.selectedDisciplines.length === 2}
          background={"white"}
          value={discipline.name}
          onChange={(e) =>
            setDiscipline((old) => {
              return { ...old, name: e.target.value };
            })
          }
        />
        <Input
          margin={"10px"}
          width="xs"
          textColor={"black"}
          placeholder="Beskrivning (Ex. 1km, Pojkar 15)"
          isDisabled={props.selectedDisciplines.length === 2}
          background={"white"}
          value={discipline.description}
          onChange={(e) =>
            setDiscipline((old) => {
              return { ...old, description: e.target.value };
            })
          }
        />
        <Checkbox
          borderColor={"black"}
          checked={discipline.groupSize !== null}
          isChecked={discipline.groupSize !== null}
          isDisabled={props.selectedDisciplines.length === 2}
          colorScheme="green"
          onChange={(e) =>
            setDiscipline((old) => {
              return { ...old, groupSize: old.groupSize !== null ? null : 2 };
            })
          }
        >
          Lag
        </Checkbox>
        {discipline.groupSize !== null && (
          <NumberInput
            maxW={200}
            min={2}
            max={10}
            isDisabled={props.selectedDisciplines.length === 2}
            value={discipline.groupSize + " pers"}
            background={"white"}
            onChange={(val) =>
              setDiscipline((old) => {
                return { ...old, groupSize: parseTeamSize(val) ?? null };
              })
            }
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        )}
      </HStack>
      <HStack margin={"10px"}>
        <Checkbox
          borderColor={"black"}
          checked={discipline.minAge !== null}
          isChecked={discipline.minAge !== null}
          isDisabled={props.selectedDisciplines.length === 2}
          colorScheme="green"
          onChange={() => {
            setDiscipline((old) => {
              return { ...old, minAge: old.minAge !== null ? null : 0 };
            });
          }}
        >
          Minimum ålder
        </Checkbox>
        {discipline.minAge !== null && (
          <NumberInput
            maxW={20}
            min={0}
            max={110}
            isDisabled={props.selectedDisciplines.length === 2}
            value={discipline.minAge ?? undefined}
            background={"white"}
            onChange={(val) =>
              setDiscipline((old) => {
                return { ...old, minAge: parseInt(val) };
              })
            }
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        )}
        <Checkbox
          marginLeft={"40px"}
          borderColor={"black"}
          isDisabled={props.selectedDisciplines.length === 2}
          checked={discipline.maxAge !== null}
          isChecked={discipline.maxAge !== null}
          colorScheme="green"
          onChange={() => {
            setDiscipline((old) => {
              return { ...old, maxAge: old.maxAge !== null ? null : 0 };
            });
          }}
        >
          Maximum ålder
        </Checkbox>
        {discipline.maxAge !== null && (
          <NumberInput
            maxW={20}
            min={discipline.minAge ?? 0}
            max={110}
            isDisabled={props.selectedDisciplines.length === 2}
            value={discipline.maxAge ?? undefined}
            background={"white"}
            onChange={(val) => {
              setDiscipline((old) => {
                return { ...old, maxAge: parseInt(val) };
              });
            }}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        )}
      </HStack>
      <HStack margin={"10px"}>
        <Tooltip label="Information av intresse för resultatlistor.">
          <Text marginRight={"20px"}>Kön: </Text>
        </Tooltip>
        <RadioGroup
          onChange={setGenders}
          value={genders ?? gendersToString(discipline.genderRequirements)}
          colorScheme="green"
        >
          <HStack spacing={5}>
            <Radio
              borderColor={"black"}
              borderWidth={"1px"}
              background={"white"}
              value={GENDER_IRRELEVANT}
            >
              Orelevant
            </Radio>
            <Radio
              borderColor={"black"}
              borderWidth={"1px"}
              background={"white"}
              value={GENDER_MAN}
            >
              Man
            </Radio>
            <Radio
              borderColor={"black"}
              borderWidth={"1px"}
              background={"white"}
              value={GENDER_WOMAN}
            >
              Kvinna
            </Radio>
            <Radio
              borderColor={"black"}
              borderWidth={"1px"}
              background={"white"}
              value={GENDER_ASK}
            >
              Fråga vid anmälan
            </Radio>
          </HStack>
        </RadioGroup>
      </HStack>

      <HStack marginBottom={"10px"} marginLeft={"10px"}>
        <Tooltip label="Spara resultat som individuell tid eller en tid per lag">
          <Text>Resultat typ: </Text>
        </Tooltip>
        <RadioGroup
          onChange={(val) =>
            setDiscipline((old) => {
              return { ...old, resultType: stringToResultType(val) };
            })
          }
          value={resultTypeToString(discipline.resultType)}
          colorScheme="green"
        >
          <HStack spacing={5}>
            <Radio
              borderColor={"black"}
              borderWidth={"1px"}
              background={"white"}
              value={resultTypeToString(ResultType.INDIVIDUAL)}
            >
              Individiella tider
            </Radio>
            <Radio
              borderColor={"black"}
              borderWidth={"1px"}
              background={"white"}
              value={resultTypeToString(ResultType.GROUP)}
            >
              En tid per lag
            </Radio>
          </HStack>
        </RadioGroup>
      </HStack>
      <HStack marginBottom={"10px"} marginLeft={"10px"}>
        <Text>Distans (i meter):</Text>
        <NumberInput
          maxW={300}
          min={0}
          defaultValue={0}
          background={"white"}
          isDisabled={props.selectedDisciplines.length === 2}
          onChange={(value) =>
            setDiscipline((old) => {
              return { ...old, distanceInMeters: parseDistance(value) };
            })
          }
          value={discipline.distanceInMeters + " m"}
        >
          <NumberInputField />
        </NumberInput>
      </HStack>
      <HStack marginLeft={"10px"}>
        <Text>Anmälningsavgift:</Text>
        <NumberInput
          maxW={300}
          min={0}
          defaultValue={0}
          background={"white"}
          isDisabled={props.selectedDisciplines.length === 2}
          onChange={(value) =>
            setDiscipline((old) => {
              return { ...old, signupCostInSek: parseFee(value) };
            })
          }
          value={discipline.signupCostInSek + " kr"}
        >
          <NumberInputField />
        </NumberInput>
      </HStack>
      <VStack align={"left"} marginLeft={"10px"} marginTop={"10px"}>
        <Checkbox
          borderColor={"black"}
          checked={discipline.signupOpenTime !== null}
          isChecked={discipline.signupOpenTime !== null}
          isDisabled={props.selectedDisciplines.length === 2}
          colorScheme="green"
          onChange={() => {
            setDiscipline((old) => {
              return {
                ...old,
                signupOpenTime:
                  old.signupOpenTime !== null ? null : new Date().getTime(),
              };
            });
          }}
        >
          Anmälan öppettider
        </Checkbox>
        {discipline.signupOpenTime && (
          <OfiDateTimeRangePicker
            start={
              discipline.signupOpenTime == null
                ? null
                : new Date(discipline.signupOpenTime)
            }
            end={
              discipline.signupClosedTime == null
                ? null
                : new Date(discipline.signupClosedTime)
            }
            setStart={(date) => {
              setDiscipline((old) => {
                return { ...old, signupOpenTime: date?.getTime() ?? null };
              });
            }}
            setEnd={(date) => {
              setDiscipline((old) => {
                return { ...old, signupClosedTime: date?.getTime() ?? null };
              });
            }}
          />
        )}
      </VStack>
      <HStack marginTop={"20px"}>
        <Button
          visibility={
            props.selectedDisciplines.length === 2 ? "visible" : "hidden"
          }
          isDisabled={props.selectedDisciplines.length !== 2}
          colorScheme="green"
          onClick={() => {
            props.onSwitchSelectedDisciplines();
          }}
          leftIcon={<ArrowUpDownIcon />}
        >
          Byt plats
        </Button>
        <Spacer />
        <Button
          isDisabled={props.selectedDisciplines.length !== 1}
          visibility={
            props.selectedDisciplines.length > 0 ? "visible" : "hidden"
          }
          colorScheme="red"
          onClick={() => {
            props.onToggleDelete(discipline);
            setDiscipline({ ...DEFAULT_NEW_DISCIPLINE });
            setGenders(GENDER_IRRELEVANT);
          }}
        >
          {props.selectedDisciplines.length === 1 &&
          props.selectedDisciplines[0].deleted
            ? "Återställ"
            : "Delete"}
        </Button>

        <Button
          colorScheme="green"
          marginRight={"20px"}
          isDisabled={props.selectedDisciplines.length > 1}
          onClick={() => {
            if (!validDiscipline(discipline)) {
              return;
            }
            props.onSubmit(discipline);
            setDiscipline({ ...DEFAULT_NEW_DISCIPLINE });
            setGenders(GENDER_IRRELEVANT);
          }}
        >
          {discipline.id === NOT_VALID_TEMP_ID ? "Lägg till" : "Uppdatera"}
        </Button>
      </HStack>
    </Box>
  );
}

export function createDescription(
  baseDescription: string,
  minAge: number | null,
  maxAge: number | null,
  eventStartTime: Date
) {
  return (
    baseDescription + " " + createAgeSpanString(minAge, maxAge, eventStartTime)
  );
}

function createAgeSpanString(
  minAge: number | null,
  maxAge: number | null,
  eventStartTime: Date
) {
  const year = eventStartTime
    ? eventStartTime.getFullYear()
    : new Date().getFullYear();
  const minYear = minAge == null ? "" : year - minAge;
  const maxYear = maxAge == null ? "" : year - maxAge;
  if (minYear && maxYear) {
    if (minYear == maxYear) {
      return `(${maxYear})`;
    }
    return `(${maxYear} - ${minYear})`;
  } else if (minYear) {
    return `(${minYear} och äldre)`;
  } else if (maxYear) {
    return `(${maxYear} och yngre)`;
  }
  return "";
}

function validDiscipline(discipline: Discipline_GET) {
  return (
    FieldValidator.notBlank(discipline.name, "Startgrupp") &&
    FieldValidator.notBlank(discipline.description, "Startgrupp") &&
    FieldValidator.greaterThan(discipline.distanceInMeters, 0, "Distans")
  );
}

function PaymentOption(props: {
  value: (PaymentMethod & { selected: boolean }) | undefined;
  name: string;
  description: string;
  allowSettingRequireManualVerify: boolean;
  onChange: (
    selected: boolean,
    fee: number,
    requireManualVerification: boolean
  ) => void;
}) {
  const selected = props.value?.selected || false;
  const fee = props.value?.feeInSek || 0;
  const manVerify = props.allowSettingRequireManualVerify
    ? props.value?.requireManualVerify || false
    : false;

  return (
    <VStack marginTop={"30px"} align={"left"} spacing={4}>
      <Checkbox
        borderColor={"black"}
        isChecked={selected || false}
        colorScheme="green"
        textColor={selected ? "black" : "gray.500"}
        onChange={(e) => {
          props.onChange(!selected, fee, manVerify);
        }}
      >
        {props.name}
      </Checkbox>
      {selected && (
        <VStack marginLeft={"30px"} align={"left"} spacing={4}>
          <Box
            shadow={"xl"}
            maxWidth={"500px"}
            background={"green.100"}
            borderWidth={"1px"}
            borderStyle={"dashed"}
            borderColor={"black"}
            borderRadius={"5px"}
          >
            <Text margin={"10px"}>{props.description}</Text>
          </Box>
          <HStack>
            <Text>Betalningsavgift:</Text>
            <NumberInput
              maxW={200}
              min={0}
              max={50}
              value={fee + " kr"}
              background={"white"}
              onChange={(val) => {
                props.onChange(selected, parseFee(val), manVerify);
              }}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </HStack>
          <HStack hidden={!props.allowSettingRequireManualVerify}>
            <Switch
              isChecked={manVerify}
              onChange={() => {
                props.onChange(selected, fee, !manVerify);
              }}
            />
            <Text>
              {manVerify
                ? "Verifiering: Tillägg i startlista och bekräftelsemail väntar på verifierad betalning."
                : "Ingen verifiering: Tillägg i startlista och bekräftelsemail skickas innan betalning verifierats."}
            </Text>
          </HStack>
        </VStack>
      )}
    </VStack>
  );
}

const parseFee = (value: string) => {
  return parseInt(value?.replace(/\s*kr.*$/, ""));
};

const parseDistance = (value: string) => {
  return parseInt(value?.replace(/\s*m.*$/, ""));
};

const parseTeamSize = (value: string) => {
  return parseInt(value?.replace(/\s*pers.*$/, ""));
};

function getNextTempId(disciplines: Discipline_GET[]) {
  if (disciplines.length == 0) {
    return NOT_VALID_TEMP_ID - 1;
  }
  return Math.min(
    NOT_VALID_TEMP_ID - 1,
    disciplines.map((d) => d.id).sort((a, b) => a - b)[0] - 1
  );
}

function getNextPosition(disciplines: Discipline_GET[]) {
  if (disciplines.length == 0) {
    return NOT_VALID_POSITION + 1;
  }

  return disciplines.map((d) => d.displayOrder).sort((a, b) => b - a)[0] + 1;
}

function saveDisciplines(competitionId: number, disciplines: Discipline_GET[]) {
  disciplines.forEach((d) => {
    const dto = { ...d } as any;
    delete dto["id"];
    if (d.id > NOT_VALID_TEMP_ID) {
      DisciplineClient.admin.putDiscipline(d.id, dto as Discipline_POST_PUT);
    } else {
      DisciplineClient.admin.postDiscipline(
        competitionId,
        dto as Discipline_POST_PUT
      );
    }
  });
}

function savePaymentMethods(
  competition: Competition_GET,
  paymentMethods: PaymentMethod[]
) {
  console.log("Updationg payment methods to, ", paymentMethods);
  const { id, ...competitionWithoutId } = competition;
  CompetitionClient.admin.putCompetition(competition.id, {
    ...competitionWithoutId,
    paymentMethods: paymentMethods,
  });
}

function StartnumberSeriesEditView(props: {
  competitionId: number;
  competitionTag: string | null;
  onUpdate: (a: Array<StartnumberSequencesDto>) => void;
}) {
  const [startnumbers, isLoadingStartnumbers, setStartnumbers] =
    useAwaitResponse(
      [] as Array<StartnumberSequencesDto>,
      () =>
        DisciplineClient.admin.getStartnumbers(
          props.competitionTag ?? "NO_COMPETITION_TAG"
        ),
      (response) => response.body ?? ([] as Array<StartnumberSequencesDto>)
    );

  useEffect(() => {
    props.onUpdate(startnumbers);
  }, [startnumbers]);

  if (isLoadingStartnumbers) {
    return <Spinner />;
  }

  return (
    <>
      {(startnumbers || []).map((s, i) => (
        <HStack
          key={s.disciplineId}
          background={i % 2 == 0 ? "blue.200" : "gray.100"}
          padding={"10px"}
        >
          <Text fontSize={"lg"}>{s.disciplineName}</Text>
          <Spacer />
          <Input
            background={"white"}
            fontWeight={"bold"}
            marginLeft={"30px"}
            fontSize={"lg"}
            maxWidth={"75%"}
            value={s.sequences}
            onChange={(e) => {
              const newVal = e.target.value
                .replace(/[^0-9,:]/g, "")
                .replace(/(\D)\D+/g, "$1")
                .replace(/(^|\D)0(\d+)/g, "$1$2");
              const controlSequence = newVal.replace(/\d/g, "");
              if (!controlSequence.match(/^.*(::|,,).*$/)) {
                setStartnumbers((old) =>
                  old.map((seq) => {
                    return seq.disciplineId === s.disciplineId
                      ? { ...s, sequences: newVal }
                      : seq;
                  })
                );
              }
            }}
          />
        </HStack>
      ))}
    </>
  );
}
